import { put, takeLatest } from 'redux-saga/effects';
import {
  OperationsMenuActions,
  CodePanelActions,
  ExampleGalleryActions,
  embeddingTypeString,
  EnvironmentSettingActions,
} from '../../constants';
import { updateDefaultTemplateForEmbeddingType } from '../../utils/templateGenerator';

// used to switch between types of the embedding: Bot, Dashboard, Visualization, Library
function* switchEmbedType(action) {
  // save embedding type to localstorage
  if (window.localStorage) {
    localStorage.setItem(embeddingTypeString, action.embeddingType);
  }

  // get the default template code for the embedding type
  const content = yield updateDefaultTemplateForEmbeddingType(action.embeddingType);
  // update the code panel with the default template code
  yield put({ type: CodePanelActions.UPDATE_CONTENT, content, updateLocalContent: true });
  // update the embedding type in the operations menu redux store
  yield put({ type: EnvironmentSettingActions.CHANGE_TYPE, embeddingType: action.embeddingType });
  // do not empty the exampleId in ExampleGallery store if the user is using the 'Copy Link' feature
  if (!action.useExampleId) {
    // empty the exampleId in ExampleGallery store if embedding type changes
    yield put({ type: ExampleGalleryActions.SET_EXAMPLE_ID, exampleId: '' });
  }
}

// used to switch between subtypes of the embedding: Bot vs Bot_Api vs Bot_Auto vs Bot_AutoImage
function* switchEmbedSubType(action) {
  // save embedding type to localstorage
  if (window.localStorage) {
    localStorage.setItem(embeddingTypeString, action.embeddingSubType);
  }

  // update the embedding type in the operations menu redux store
  yield put({
    type: EnvironmentSettingActions.CHANGE_TYPE,
    embeddingType: action.embeddingSubType,
  });
  // empty the exampleId in ExampleGallery store if embedding type changes
  yield put({ type: ExampleGalleryActions.SET_EXAMPLE_ID, exampleId: '' });
}

export default function* operationsMenuSaga() {
  yield takeLatest(OperationsMenuActions.SAVE_CHANGE_TYPE, switchEmbedType);
  yield takeLatest(OperationsMenuActions.SAVE_CHANGE_SUB_TYPE, switchEmbedSubType);
}
